import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/thumbs'; 
import { initCarSinglePageModal } from './utils/functions.js';
import { formatPrice } from './utils/functions.js';
import { returnOnlyNumbers } from './utils/functions.js';
import { changeCarsImages } from './utils/functions.js';
import { initCarListModals } from './utils/functions.js';
import { copyLotNumberToBuffer } from './utils/functions.js';



document.addEventListener('DOMContentLoaded', () => {

initCarListModals();
changeCarsImages();
initCarSinglePageModal();
copyLotNumberToBuffer();
const carSwiper = document.querySelector('.car-swiper');
if (carSwiper) {
      const thumbsSwiper = new Swiper(".car__swiper-thumbs", {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true, pagination: {
                el: '.swiper-pagination-image',
                clickable: true,
            },
         
    });
    const swiper2 = new Swiper(".big-swiper", {
      spaceBetween: 10,
       slidesPerView: 1,
      thumbs: {
        swiper: thumbsSwiper,
      },   navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.car__swiper-thumbs-prev',
            },
    });   

Fancybox.bind('[data-fancybox="gallery"]', {
    caption: function() { return ''; },
     Carousel: {
    breakpoints: {
      "(max-width: 768px)": {
        Arrows: false
      }
    }
  }
  // Your custom options for a specific gallery
});

}


const carPrice = document.querySelector('.price-l-price');
const switchers = document.querySelectorAll('.switch');
if (switchers.length > 0 ) {
    switchers.forEach((ctx)=>{
        ctx.addEventListener('click',()=>{


                const currentPrice = returnOnlyNumbers(carPrice.textContent);
                const parent = ctx.closest('.item');
                parent.classList.toggle('active');
                let totalPrice;
                    const price = ctx.dataset.price;
                if (parent.classList.contains('active')) {
                  totalPrice = Number(currentPrice)-Number(price);
                }
                else {
                   totalPrice = Number(currentPrice)+Number(price);
                }

                carPrice.textContent = 'от '+formatPrice(totalPrice)+' ₽';
            
                console.log(price)
        });
    });
}



const tabs = document.querySelectorAll('.tabs .item');
const contents = document.querySelectorAll('.tabs-content .item');




tabs.forEach((tab,index)=>{
tab.addEventListener('click',()=>{
      tabs.forEach(t => t.classList.remove('active'));
       contents.forEach(c => c.classList.remove('active'));
  tab.classList.add('active');
        contents[index].classList.add('active');
});

});

function debounce(func, delay) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
}


const mobileBlockPriceContainer = document.querySelector('.mobile-price');
const stickyBlock = document.querySelector('.sticky');
const desktopContainer =  document.querySelector('.sticky-wrap');

const debounced = debounce(() => {

if (window.innerWidth <= 1070 ) {
  mobileBlockPriceContainer.appendChild(stickyBlock);
}
else {
  desktopContainer.appendChild(stickyBlock);
}

}, 200);


debounced();

window.addEventListener('resize', debounced); 



const showAllComplectBut = document.querySelector('.car-mobile-show-more');

  showAllComplectBut.addEventListener('click',()=>{
  const complectContainer = document.querySelector('.complectation');
  complectContainer.classList.toggle('active');
  showAllComplectBut.classList.toggle('active');


  if (showAllComplectBut.textContent == 'Показать полностью') {
    showAllComplectBut.textContent = 'Скрыть';
  }
  else {
     showAllComplectBut.textContent = 'Показать полностью';
     complectContainer.scrollIntoView(true);
  }


  });






});